<template>
  <div class="cp67-main" v-if="body_show">
    <public-top-tips v-show="data.uid && data.uid < 0"></public-top-tips>

    <div class="cep61_top">
      <h1>{{data.headtitle}}</h1>
      <h2>测试者：{{data.nickname}}</h2>
      <h3>{{data.ctime}}</h3>
      <!-- <a @click="reset" v-if="data.past_days>=30">重新测试</a>
      <a v-else style="background-color:#ccc">{{30-data.past_days}} 天后可重测</a> -->
    </div>

    <div class="cep61_main" v-if="data.activity_poster">
      <h1><img class="left" src="@a/cep61_2.png">测评报告专属海报<img class="right" src="@a/cep61_1.png"></h1>
      <div class="poster">
        <img
          referrerpolicy="no-referrer"
          :src="data.activity_poster"
        />
      </div>
      <div class="save-btn">
        <span>长按图片保存</span>
      </div>
    </div>

    <div class="cep61_main">
      <h1><img class="left" src="@a/cep61_2.png">基于兴趣主题的定位分析<img class="right" src="@a/cep61_1.png"></h1>
      <small class="small">职业兴趣主题结果</small>
      <h2 class="cep61_mh2">您的霍兰德代码</h2>
      <div class="cep61_list clearfix">
        <ul>
          <li v-for="(item,index) in data.self_result_top" :key="index">
            <h2>{{item.division}}</h2>
            <h3>
              <span v-for="(itm,idx) in item.keywords" :key="idx">{{itm}}</span>
            </h3>
          </li>
        </ul>
      </div>
      <h2 class="cep61_mh2">您的得分图</h2>

      <div class="rest-box" v-show="!showDetail">
        <div class="unlock-box">
          <span class="unlock-text">已解锁20%</span>
        </div>
        <div class="helper-title">长按识别下方二维码，解锁全部报告</div>
        <div class="helper-text">解锁全部报告后，还可以把完整版报告发送邮箱哦</div>
        <div class="helper-img">
          <img src="@a/growth/qrcode_sydyr.png">
        </div>
        <div class="helper-name">小助手</div>
      </div>

      <div v-show="showDetail">
        <div class="dimension_bg">
          <div id="dimension" class="dimension"></div>
        </div>
        <div class="cep61_list1 clearfix">
          <ul>
            <li v-for="(item,index) in data.self_result_desc" :key="index">
              <h2>{{item.division}}</h2>
              <h3>{{item.avg}}</h3>
            </li>
          </ul>
        </div>
        <!-- 第二段 -->
        <small class="small small2">兴趣主题结果详解</small>
        <h2 class="cep61_mh2">天生兴趣</h2>
        <div class="cep61_list3">
          <ul>
            <li v-for="(item,index) in data.self_result_top" :key="index" class="clearfix">
              <img src="@a/dian.png" alt="" />
              <div class="cep61_lr">{{item.interest}}</div>
            </li>
          </ul>
        </div>
        <h2 class="cep61_mh2">职业潜能 </h2>
        <h3 class="cep61_mh3">适合的工作类型： </h3>
        <div class="cep61_list3">
          <ul>
            <li v-for="(item,index) in data.self_result_top" :key="index" class="clearfix">
              <img src="@a/dian.png" alt="" />
              <div class="cep61_lr">{{item.potential}}</div>
            </li>
          </ul>
        </div>
        <h2 class="cep61_mh2">发挥与创造</h2>
        <h4 class="cep61_mh4">无论具体从事哪项工作，您都可以遵循自己的内心，将自己对</h4>
        <div class="cep61_list5">
          <ul>
            <li v-for="(item,index) in data.self_result_top" :key="index" class="clearfix">
              {{item.creation}}
            </li>
          </ul>
        </div>
        <h4 class="cep61_mh4">转化成工作成功的动力来源。</h4>
        <p class="s-p"><span>*</span>&nbsp;更多关于6大兴趣主题的详细描述请见PDF版《职业定向报告》。</p>
        <!-- ------------------------- -->
        <!-- 第三段 -->
        <small class="small small2">基于兴趣主题代码的职业推荐</small>
        <!-- 兴趣代码职业推荐 -->
        <p  class="small-p">依据你的职业兴趣代码，为你推荐相关的职业。因为职业代码是三个码的组合，为了呈现更多的可能性，我们将列出所有可能的组合所对应的职业，供你参考。</p>
        <div class="cep61_list2">
          <ul>
            <li v-for="(item,index) in data.recommend" :key="index" v-if="item.recommendation!=''">
              <h2>{{item.report_key}}</h2>
              <h3>{{item.recommendation}}</h3>
            </li>
          </ul>
        </div>
        <!-- 职业示例 -->
        <h3 class="cep61_mh3 cep67_h3">职业示例： </h3>
        <div class="cep61_list2 cep61_list4 cep67_list4">
          <ul>
            <li v-for="(item,index) in data.example" :key="index" class="clearfix">
              <h2>{{item.title}}</h2>
              <h3 v-html="item.text"></h3>
            </li>
          </ul>
        </div>
        <div class="cep61_bt">
          <h2></h2>
          <div class="cep61_btv">
            列出的职业你都不感兴趣？
            <br/>你可以不拘泥于推荐岗位，探索更多的可能职业：测评结果中的代码是最接近你职业兴趣的代码，但还存在其他的排列组合方式；同时，根据代码推荐的只是常见职业，还有其他职业也满足该职业兴趣。你可以参照岗位示例，分析其他可能满足你的职业兴趣的职业，打开可能性。
          </div>
        </div>
      </div>
      
    </div>
    <div class="cep61_main" v-show="showDetail">
      <h1><img class="left" src="@a/cep61_2.png">基于兴趣单元的定位分析<img class="right" src="@a/cep61_1.png"></h1>
      <small class="small">兴趣单元得分情况</small>
      <h5 class="cep67_h5">以下为你六个主题下28个兴趣单元的得分情况</h5>
      <!-- 统计 -->
      <!--begin  评分 -->
      <div v-for="item in data.category_result" :key="item.color" class="score-box">
        <h4 class="score-header" :style="{color:item.color}">{{item.title}}</h4>
        <ul>
          <li v-for="resItem in item.result" :key="resItem.category" >
            <label>{{resItem.category}}</label>
            <span class="bar"><span :style="{backgroundColor:item.color,width:scoreHandle(resItem.score)}"></span></span>
            <span class="num" :style="{backgroundColor:item.color}">{{resItem.score}}</span>
          </li>
          <!-- begin 刻度 -->
          <li>
            <span class="calibration">
              <span v-for="(item,index) in 6" :key="item">{{index}}</span>
            </span>
          </li>
           <!--  end刻度 -->
        </ul>
      </div>
      <!-- end 评分 -->
      <h2 class="unit">前五个最感兴趣单元详解</h2>
      <p class="instructions">以下列出了你得分较高前五的兴趣单元的总体特征、典型工作任务与相关职业。</p>
      <p class="instructions">根据霍兰德兴趣理论，不同兴趣取向的人对最能满足他兴趣的职业有更高的热情。为了帮助你更好的进行职业探索，我们为你推荐了与你的得分最高的前5项基本兴趣相关的职业。</p>
      <!-- top5 -->
      <div v-for="(item,idx) in data.top5" :key="idx" class="top5-instructions">
        <div class="top5-img">TOP{{(idx+1)+'&nbsp;'+item.category}}</div>
        <div class="top5-content">
          <p>{{item.desc}}</p>
          <h4>典型工作任务</h4>
          <p>{{item.task}}</p>
          <h4>相关职业</h4>
          <p>{{item.jobs}}</p>
        </div>
      </div>
      <!-- 注 -->
      <p class="note"><span>*</span>&nbsp;更多关于职业探索与行动的报告内容，详见PDF版《职业定向报告》。</p>
      <!--begin 发送邮箱 -->
      <div class="send-email-btn" @click="fill_emails=true">点击，将详细报告发至邮箱</div>
      <!--end 发送邮箱 -->
    </div>

    <div class="bz">
      *本测评由新精英生涯（北京）教育科技有限公司版权所有，违者必究。
    </div>
    <div class="levelbtn-group" v-if="data.activity_code">
      <!-- <a @click="goExternal" class="purple">申请一对一咨询</a> -->
      <a @click="showQrcode = true" class="purple">【获取霍兰德小课】</a>
    </div>
    <!-- 开启下一关卡 -->
    <div v-if="$route.query.level_list_id" class="levelbtn-group">
      <a @click="fill_emails=true" >将详细报告发送至邮箱</a>
      <a @click="list_link()" v-if="next.type == 1">开启“测评”</a>
      <a @click="list_link()" v-else-if="next.type == 2">开启下一课程</a>
      <a @click="list_link()" v-else-if="next.type == 3">开启“任务”</a>
      <a @click="list_link()" v-else-if="next.type == 5">去案例分析</a>
    </div>
    <!-- 关注二维码 -->
    <van-popup class="radius" :close-on-click-overlay="false" v-model="isShow">
      <div class="pop pr text-center">
        <p>你的专属报告已生成</p>
        <p>长按识别关注公众号“立即查看”</p>
        <div class="text-center">
          <img class="qr-box" :src="qrcode" alt="" />
        </div>
      </div>
    </van-popup>
    <!-- 发送邮箱弹窗 -->
    <van-popup v-model="fill_emails">
      <div class="confirm_box">
        <van-cell-group class="grouping">
          <van-field placeholder="请填写你的邮箱账号" v-model="mailbox" />
        </van-cell-group>
        <a class="cancel" href="javascript:;" @click="send_emails">确认</a>
      </div>
    </van-popup>

    <van-popup v-model="showQrcode" class="popup-container">
      <div class="popup-qrcode">
        <img src="@a/qrcode_act_816.jpeg">
      </div>
      <div class="popup-text1">
        添加班主任
      </div>
      <div class="popup-text2">
        回复【进群听课】
      </div>
    </van-popup>
  </div>
</template>
<script>
import { ceping95_report,ceping95_reset,sendPdf,ceping_event } from "@/api/measurement";
import { shareCon } from "@/utils/wxconfig";
import { deepCopy } from "@/utils/tools";
import { Dialog } from 'vant';
import { getLevel} from "@/api/course"

import PublicAdQrcode from "@c/measurement/public-ad-qrcode";
import PublicTopTips from "@c/measurement/public-top-tips";

export default {
  data() {
      return {
        body_show: false,
        data: {},
        isShow: false,
        qrcode: '',
        fl_group: [],
        type_obj: {
          evaluation_id: "",
          evaluation_name: "",
          evaluation_id: "",
          nickname: ""
        },
        fill_emails:false,
        mailbox: '',
        // 关卡
        next:{},
        showDetail: false,
        showQrcode: false
      }
    },
    components:{
      PublicAdQrcode,
      PublicTopTips,
    },
    computed:{
      /*
       *@param: score
       *@return: score
       *@Description:计算评分宽度
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-10-14 15:27:05
      */
      scoreHandle(){
        return function(score){
          return (((300/5)*score )/2)+'px'
        } 
        
      }
    },
    methods: {
      goExternal() {
        if(this.data.activity_code) {
          ceping_event({
            cid: this.data.cid,
            event: 'ClickExternal',
          }).then(res=>{
            // 页面访问统计
            location.href = 'https://jinshuju.net/f/vCvrNH';
          });
        } else {
          location.href = 'https://jinshuju.net/f/vCvrNH';
        }
      },
      /*
       *@param: 
       *@return: 
       *@Description: 开启下一个任务  1测评2音频3任务4小组讨论5案例
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-12-05 15:58:09
      */
      list_link() {
        let item = this.next;
        if (item.type == 1) {
          if(item.link.startsWith('http')){
            window.location.href = item.link+'?level_list_id=' + item.id;
          }else{
            this.$router.push({
              path:item.link,
              query:{
                level_list_id:item.id
              }
            })
          }
        } else if (item.type == 2) {
          this.$router.push('/course_content?cid=' + item.cid + '&level_list_id=' + item.id+'&cpid=' + item.cpid + '&id=' + item.table_id)
        } else if (item.type == 3) {
          this.$router.push(item.link + '?cid=' + item.cid + '&level_list_id=' + item.id+'&pid=' + item.cpid + '&id=' + item.table_id)
        } else if (item.type == 5) {
          this.$router.push('/case_analysis?id=' + item.id + '&level_list_id=' + item.id+'&cid=' + item.cid)
        }
      },
      /*
       *@param: 
       *@return: 
       *@Description: 发送报告邮箱
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-10-14 17:40:59
      */
      send_emails() {
        if (this.$Validator.isEmail(this.mailbox)) {
          //调用加载中
          this.$emit('loadingHandle',true,"发送中");
          let q = this.$route.query;
          let ev_obj= {
            cid: 95,
            touser: this.mailbox
          };
          if(q.evaluation_id || q.evaluation_id==0){
            ev_obj['evaluation_id'] = q.evaluation_id;
          }
          sendPdf(ev_obj).then((data) => {
            //关闭加载中
            this.$emit('loadingHandle',false);
            this.$toast(data.msg);
            setTimeout(() => {
              this.fill_emails = false
            },200)
          }).catch(() => {
            //关闭加载中
            this.$emit('loadingHandle',false);
            this.$toast('报告发送可能有几分钟的延迟，请耐心等待。');
            setTimeout(() => {
              this.fill_emails = false
            },200)
          });
        } else {
          this.$toast('邮箱填写不正确！');
        }

      },
      /*
       *@param: 
       *@return: 
       *@Description: 重新测评
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-10-14 17:40:46
      */
      reset() {
        Dialog.confirm({
          title: '重新测评',
          message: '您确认要重测吗？'
        }).then(() => {
          ceping95_reset()
            .then((data) => {
              this.$router.push("/ceping95")
            })
        }).catch(() => {
          // on cancel
        });
      },
      dimension_chart() {
        let dimension = echarts.init(document.getElementById('dimension'));
        let dimension_indicator = [];
        let dimension_value = [];
        let arry = [];
        arry.push(this.data.self_result[0]);
        arry.push(this.data.self_result[5]);
        arry.push(this.data.self_result[4]);
        arry.push(this.data.self_result[3]);
        arry.push(this.data.self_result[2]);
        arry.push(this.data.self_result[1]);

        for (let attr in arry) {
          dimension_indicator.push({
            text: arry[attr].division + '. ' + arry[attr].type,
            max: 5
          });
          dimension_value.push(arry[attr].avg);
        }
        let option = {
          tooltip: {
            trigger: 'axis'
          },
          radar: [{
            indicator: dimension_indicator,
            center: ['50%', '62%'],
            splitLine: {
              lineStyle: {
                  type: "dashed",
                  width: 1
              }
            },
            axisLine: {
              lineStyle: {
                  type: "dashed",
                  width: 1
              }
            },
            name: {
              textStyle: {
                color: '#E8576F',
                padding: [
                  0, // 上
                  0, // 右
                  20, // 下
                  0, // 左
                ]
              }
            },
            startAngle: 120,
            radius: 80
          }],

          series: [{
            type: 'radar',
            areaStyle: {
              normal: { //区域填充样式
                color: '#FADDE2',
                // opacity: '0.6'
              }
            },
            itemStyle: { //折线拐点标志的样式
              color: '#E8576F',
            },
            data: [{
              name: '得分',
              value: dimension_value,
              label: {
                normal: {
                  show: true,
                  formatter: function(params) {
                    return params.value;
                  }
                }
              }
            }]
          }]
        };

        // 为echarts对象加载数据
        dimension.setOption(option);
      },
      pullData() {
        //调用加载中
        this.$emit('loadingHandle',true,"拼命加载中...");
        let q = this.$route.query;
        // 获取关卡信息
        this.level_list_id = q.level_list_id?q.level_list_id:'';

        if(q.level_list_id){
          getLevel({
            level_list_id:this.level_list_id
          }).then((data)=>{
            this.next = data.next;
          });
        }
        let ev_obj= {};
        if(q.evaluation_id || q.evaluation_id==0){
          ev_obj['evaluation_id'] = q.evaluation_id;
        }
        ceping95_report(ev_obj).then((data) => {
          if (data.code != '10002') {
            document.title = data.headtitle;
            this.body_show = true;

            this.data = data;
            this.qrcode = data.qrcode;
            if (this.data.need_subscribe && !this.data.subscribe) {
              this.isShow = true;
            };

            if(this.data.activity_code) {
              ceping_event({
                cid: data.cid,
                event: 'ViewReport',
              }).then(res=>{
                // 页面访问统计
              });

              // if(this.data.activity_code != 'ACT_SYDYR' || q.unlock == '2ede9e5545f61763cdfd19234b98de43') {
                this.showDetail = true;
              // }
            }
            
            // 给wxconfig传对象
            this.type_obj.nickname = data.nickname;
            this.type_obj.evaluation_id = data.cid;
            this.type_obj.evaluation_name = data.headtitle;
            this.type_obj.evaluation_user_id = String(data.uid);
            this.type_obj.path = this.$route.path;

            shareCon("ceping95", this, this.type_obj);
            setTimeout(() => {
              this.dimension_chart();
            }, 1000);
          } else {
            let redirect_query = deepCopy(this.$route.query);
            if(redirect_query.evaluation_id) {
              delete redirect_query.evaluation_id;
            }
            // 未测评完成query:
            this.$router.push({
              path:'/ceping95',
              query: redirect_query
            })
          }
          //关闭加载中
          this.$emit('loadingHandle',false);
        })
      }
    },
    created() {
      this.pullData();
    }
}
</script>
<style lang="scss">
@import "@s/remChange.scss";

.rest-box {
  margin: -60px -30px -20px;

  .unlock-box {
    position: relative;
    height: 126px;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.2) 0%, rgba(211, 211, 211, 0.7) 100%);

    .unlock-text {
      font-size: 32px;
      font-weight: 600;
      color: #0890CE;
      line-height: 44px;
      text-align: center;
      position: absolute;
      left: 0;
      right: 0;
      bottom: 14px;
    }
  }

  .helper-title {
    font-size: 32px;
    font-weight: 600;
    color: #FF6010;
    line-height: 44px;
    text-align: center;
    margin-top: 60px; 
  }

  .helper-text {
    height: 34px;
    font-size: 24px;
    font-weight: 400;
    color: #606060;
    line-height: 34px;
    text-align: center;
    margin: 20px 0;
  }

  .helper-img {
    width: 252px;
    height: 252px;
    margin: 0 auto;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .helper-name {
    font-size: 32px;
    font-weight: 400;
    color: #606060;
    line-height: 44px;
    margin-top: 20px;
    text-align: center;
  }
}

.cp67-main{
  padding-bottom: 138px;
}
.dimension_bg {
  background: url(../../../assets/dema_bg.png) no-repeat top center;
  background-size: cover;
  width: 100%;
  height: 630px;
}

.dimension {
  margin: 0 auto;
  height: 510px;
  margin: 30px auto;
  -webkit-tap-highlight-color: transparent;
  user-select: none;
  position: relative;
}

.radius {
  border-radius: 10px;
}

.pop {
  width: 8rem;
  padding-bottom: 80px;
  p:nth-child(1) {
    padding-top: 50px;
    font-size: 34px;
    line-height: 80px;
    font-weight: bold;
    color: #F57F17;
  }
  p:nth-child(2) {
    color: #333;
    font-size: 30px;
    line-height: 80px;
  }
  img {
    width: 80%;
  }
}

.cep61_top {
  width: 100%;
  background: url(../../../assets/cep61_t.png) no-repeat top center;
  background-size: cover;
  height: 470px;
  padding: 0 60px;
  padding-top: 72px;
  color: #333;
  h1 {
    font-size: 50px;
    font-weight: bold;
  }
  h2 {
    font-size: 26px;
    margin-top: 30px;
  }
  h3 {
    font-size: 20px;
    margin-top: 20px;
  }
  a {
    display: block;
    margin-top: 40px;
    width: 240px;
    height: 55px;
    background: rgba(232, 87, 111, 1);
    border-radius: 8px;
    font-size: 30px;
    color: #fff;
    line-height: 55px;
    text-align: center;
  }
}
.cep67_h5{
  margin: 70px 0;
  text-align: left;
  font-size: 26px;
  color: #333333;
}
// 评分
.score-box{
  border-bottom: 2px solid #EEEEEE;
  margin-bottom: 34px;
  &:last-of-type{
    margin-bottom: 0;
    border: 0;
  }
  .score-header{
    font-size: 28px;
    font-weight: bold;
  }
  ul {
    margin-top: 35px;
    li{
      display: flex;
      align-items: center;
      margin-bottom: 25px;
      &:last-child{
        margin-bottom: 34px;
      }
      label{
        font-size: 26px;
        color: #333333;
        line-height: 1;
        margin-left: auto;
      }
      span.bar{
        width:300px;
        height:22px;
        background:#F0F0F0;
        border-radius:11px;
        margin: 0 39px;
        overflow: hidden;
        span{
          display: block;
          height: 100%;
        }
      }
      span.num{
        width:44px;
        line-height:22px;
        background:#E8576F;
        border-radius:11px;
        font-size: 18px;
        color: #FFFFFF;
        text-align: center;
      }
      .calibration{
        margin-left: auto;
        margin-right: 78px;
        width: 310px;
        display: flex;
        justify-content: space-between;
        font-size: 20px;
        color: #999999;
      }
    }
  }
}
// 最感兴趣的五个单元详解
.unit{
  font-size: 40px;
  color: #333333;
  margin: 100px auto 70px;
  text-align: center;
  font-weight: bold;
}
.instructions{
  font-size: 26px;
  color: #333333;
  line-height: 39px;
  margin-bottom: 50px;
  &:last-of-type{
    margin-bottom: 84px;
  }
}
.top5-instructions{
  margin-bottom: 50px;
  .top5-img{
    margin-bottom:-16px;
    text-align: left;
    line-height:82px;
    height:98px;
    background: url(../../../assets/unit-top.png) left no-repeat;
    background-size: 403px 98px;
    font-size: 32px;
    color: #FFFFFF;
    padding-left: 25px;
  }
  .top5-content{
    border-radius:15px;
    background-color: #FEF6F8;
    padding: 30px 26px;
    h4{
      font-size: 28px;
      color: #E8576F;
      margin: 58px auto 40px;
    }
    p{
      font-size: 26px;
      color: #333333;
      line-height: 39px;
    }
  }
}
// 注
.note{
  font-size: 26px;
  color: #333333;
  margin-bottom: 50px;
  span{
    color: #E8576F;
  }
}
// 发送邮箱按钮
.send-email-btn{
  font-size: 34px;
  text-align: center;
  color: #333333;
  line-height:80px;
  background:#FCD94B;
  border-radius:8px;
  margin-bottom: 10px;
}
.bz {
  margin: 40px auto 0px;
  font-size: 24px;
  color: #999;
  text-align: center;
}
.confirm_box {
  padding: 50px 40px;
  border-radius: 12px;
}

.confirm_box h3 {
  margin: 10px 0;
  color: #999;
  font-size: 26px;
  text-align: center;
}

.confirm_box a.cancel {
  color: #fff;
  background-color: #EB5032;
  line-height: 60px;
  text-align: center;
  font-size: 28px;
  display: block;
  margin: 0 auto;
  margin-top: 40px;
  border-radius: 8px
}

.grouping .van-cell .van-cell__value input {
  border: 2px solid #ccc;
  border-radius: 12px;
  font-size: 26px;
  color: #333;
}
// 
.cep61_main {
  .poster {
    width: 100%;
    text-align: center;
    vertical-align: bottom;
    margin-top: 40px;

    img {
      max-width: 100%;
    }
  }

  .save-btn {
    position: relative;
    width: 100%;
    height: 66px;
    margin-top: 30px;

    span {
      position: absolute;
      top: 0;
      left: 50%;
      margin-left: -120px;
      width: 240px;
      height: 56px;
      text-align: center;
      color: rgba(232, 87, 111, 1);
      font-size: 30px;
      white-space: nowrap;
      line-height: 56px;
      border-radius: 6px;
      border-width: 1PX; /*no*/
      border: 1PX solid rgba(232, 87, 111, 1);
      background-color: rgba(255, 255, 255, 1);
      box-sizing: border-box;
      z-index: 11;
    }

    &:after {
      content: ' ';
      position: absolute;
      top: 0;
      left: 50%;
      margin-left: -110px;
      margin-top: 10px;
      width: 240px;
      height: 56px;
      text-align: center;
      color: rgba(232, 87, 111, 1);
      font-size: 30px;
      white-space: nowrap;
      line-height: 56px;
      border-radius: 6px;
      border-width: 1PX; /*no*/
      border: 1PX solid rgba(232, 87, 111, 1);
      background-color: rgba(255, 255, 255, 1);
      box-sizing: border-box;
      z-index: 10;
    }
  }

  width: 690px;
  background: rgba(255, 255, 255, 1);
  border-radius: 8px;
  margin: 0 auto;
  margin-top: 60px;
  padding: 70px 30px;
  .s-p{
    font-size:26px;
    color:#333333;
    margin-top:70px;
    span{
      color: #E8576F;
    }
  }
  .cep67_h3{
    font-size: 32px;
    color: #333333;
    margin-top: 100px;
  }
  .small-p{
    font-size: 26px;
    color: #333333;
    line-height:39px;
    margin-top: 70px;
  }
  small.small{
    display: block;
    font-weight: bold;
    margin-top: 70px;
    text-align: center;
    font-size: 40px;
    color: #333;
  }
  small.small.small2{
    margin-top: 100px;
  }
  h1 {
    display: flex;
    align-items: center;
    font-size: 46px;
    color: #E8576F;
    text-align: center;
    font-weight: bold;
    img {
      width: 44px;
      height: 16px;
      margin: 0 auto;
    }
    .right{
      // transform: rotateY(180deg);
    }
  }
  p.cep61_mp {
    font-size: 32px;
    line-height: 64px;
    color: #333;
    text-align: justify;
    margin-top: 70px;
    font-weight: bold;
  }
  h2.cep61_mh2 {
    font-size: 32px;
    color: #333;
    text-align: left;
    margin-top: 70px;
    font-weight: bold;
  }
  h3.cep61_mh3 {
    font-size: 28px;
    color: #E8576F;
    text-align: left;
    margin-top: 70px;
    font-weight: bold;
  }
  h3.cep61_mh3.cep67_h3{
    font-size: 32px;
    color: #333333;
    margin-top: 100px;
  }
  h4.cep61_mh4 {
    font-size: 26px;
    color: #333;
    text-align: justify;
    margin-top: 40px;
    line-height: 50px;
  }
  .cep61_list {
    margin-top: 40px;
    ul li {
      float: left;
      margin-right: 30px;
      width: 190px;
      text-align: center;
      h2 {
        height: 118px;
        line-height: 118px;
        background: rgba(232, 87, 111, 1);
        border-radius: 8px 8px 0px 0px;
        color: #fff;
        font-size: 60px;
      }
      h3 {
        height: 118px;
        line-height: 44px;
        background: #F0F0F0;
        color: #333;
        font-size: 28px;
        padding-top: 20px;
        span {
          display: block;
        }
      }
    }
    ul li:last-child {
      margin-right: 0;
    }
  }
  .cep61_list1 {
    margin-top: 40px;
    ul li {
      float: left;
      margin-right: 2px;
      width: 103px;
      text-align: center;
      h2 {
        height: 60px;
        line-height: 60px;
        background: rgba(232, 87, 111, 1);
        color: #fff;
        font-size: 32px;
      }
      h3 {
        height: 60px;
        line-height: 60px;
        background: #F0F0F0;
        color: #333;
        font-size: 26px;
      }
    }
    ul li:last-child {
      margin-right: 0;
    }
  }
  .cep61_list2 {
    ul li {
      margin-top: 60px;
      h2 {
        color: #E8576F;
        font-size: 28px;
      }
      h3 {
        color: #333;
        margin-top: 40px;
        line-height: 50px;
        text-align: justify;
        font-size: 28px;
      }
    }
  }
  .cep61_list3 {
    ul li {
      margin-top: 60px;
      position: relative;
      img {
        width: 11px;
        height: 11px;
        position: absolute;
        top: 20px;
        left: 0;
      }
      .cep61_lr {
        width: 596px;
        float: right;
        text-align: justify;
        color: #333;
        font-size: 26px;
        line-height: 50px;
      }
    }
  }
  .cep61_list4 {
    ul li {
      h2 {
        color: #333;
        font-size: 26px;
        font-weight: bold;
      }
      h3 {
        font-size: 26px;
      }
    }
  }
  .cep61_list4.cep67_list4{
    ul li {
      h2 {
        color: #E8576F;
        font-size: 28px;
        font-weight: bold;
      }
      h3 {
        font-size: 26px;
        margin-top: 38px;
        line-height: 39px;
      }
    }
  }
  .cep61_bt {
    margin-top: 65px;
    h2 {
      width: 630px;
      height: 30px;
      background: rgba(232, 87, 111, 1);
      border-radius: 15px 15px 0px 0px;
    }
    .cep61_btv {
      padding: 26px;
      line-height: 50px;
      font-size: 26px;
      color: #333;
      text-align: justify;
      background-color: #FEF6F8;
    }
  }
  .cep61_list5 {
    ul li {
      margin: 0 auto;
      margin-top: 60px;
      width: 440px;
      border-bottom: 2px solid #E8576F;
      padding-bottom: 14px;
      text-align: center;
      font-size: 26px;
      color: #333;
      font-weight: bold;
    }
  }
}
.levelbtn-group{
  display: flex;
  line-height: 98px;
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 50%;
  max-width: 750px;
  transform: translateX(-50%);
  z-index: 998;
  background-color: #EB5032;
  a{
    flex: 1;
    display: block;
    text-align: center;
    font-size: 32px;
    color: #ffffff;
    &:nth-child(1){
      border-right: 1px solid #ffffff;
    }
    &:last-child{
      border-left: 1px solid #ffffff;
    }

    &.purple {
      background: #E8576F;
    }
  }
}

.popup-container {
  padding: 40px 75px;
  background: #fff;
  border-radius: 8px;
}

.popup-qrcode {
  width: 340px;
  height: 340px;

  img {
    width: 100%;
  }
}

.popup-text1 {
  font-size: 28px;
  font-weight: 600;
  color: #333;
  line-height: 40px;
  text-align: center;
  margin-top: 20px;
}

.popup-text2 {
  font-size: 32px;
  font-weight: 600;
  color: #333;
  line-height: 45px;
  text-align: center;
  margin-top: 9px;
}
</style>
